export default "__VITE_ASSET__77c977e5__"